import styled from 'styled-components'

import { Button } from '@radix-ui/themes'

export const StyledImageUploading = styled.div``

export const ClearAllButton = styled(Button)`
    display: inline-block;
    height: 4rem;
    padding-inline: 1rem;
    border-radius: 1rem;
`

export const DropDiv = styled.div`
    border: 2px solid var(--gray-7);
    background-color: var(--gray-4);
    border-radius: 1rem;
    height: 5rem;
    width: 15rem;
    display: grid;
    place-items: center;
    cursor: pointer;

    &:hover {
        background-color: var(--gray-6);
    }
`

export const HeaderButtons = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
`

export const ImageTable = styled.div`
    margin: 1rem !important;
`
